module.exports = __webpack_public_path__ + "static/media/funnel.bb3c0ef6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/assets/funnel.svg
// module id = 260
// module chunks = 0